export default {
	tab: "Reservas",
	reserveConsultant: "Reservar consultante",
	pending: "Pendientes",
	confirmed: "Correo confirmado",
	awaitingConfirm: "Correo no confirmado",
	receivedAt: "Recibida el",
	noEmailStatus: "Sin correo",
	viewDetails: "Ver detalles",
	phone: "Teléfono",
	email: "Correo electrónico",
	approve: "Aprobar",
	reject: "Rechazar",
	expected: "Reservados",
	noExpected: "Nadie reservado aún.",
	noPending: "Ninguna reserva pendiente.",
	noRejected: "Ninguna reserva rechazada.",
	originPublic: "Pública",
	originInternal: "Interna",
	rejected: "Rechazadas",
	approveTitle: "Aprobar reserva",
	linkExisting: "Consultante existente",
	createNew: "Registrar nuevo",
	consultant: "Consultante",
	attendanceType: "Tipo de atención",
	groupByType: "Agrupar por tipo de atención",
	noType: "Sin tipo",
	attendanceTypeHint: "La reserva garantiza una ficha de ese tipo; los tipos llenos quedan indisponibles.",
	unlimited: "sin límite",
	full: "lleno",
	selectType: "Selecciona el tipo de atención.",
	firstName: "Nombre",
	lastName: "Apellido",
	rejectTitle: "Rechazar reserva",
	rejectReason: "Motivo (opcional)",
	notes: "Observación (opcional)",
	reserve: "Reservar",
	reserved: "¡Consultante reservado!",
	approved: "¡Reserva aprobada!",
	rejectedDone: "Reserva rechazada.",
	loadError: "Error al cargar las reservas.",
	saveError: "No se pudo completar. Inténtalo de nuevo.",
	selectConsultant: "Selecciona el consultante.",
	firstNameRequired: "Ingresa el nombre.",
	attended: "Atendida",
	cancelReservation: "Cancelar reserva",
	editTitle: "Editar reserva",
	cancelTitle: "Cancelar reserva",
	cancelConfirm: '¿Cancelar la reserva de "{name}"? El cupo quedará libre.',
	saved: "¡Reserva actualizada!",
	cancelled: "Reserva cancelada.",
	exportExcel: "Excel",
	printTitle: "Reservas del ritual",
	origin: "Origen",
	status: "Estado",
	awaitingAttendance: "En espera",
	contact: "Contacto",
};
